'use strict';

module Patersons {

    export interface VerifyPhoneScope extends ng.IScope {   
        phoneForm: ng.IFormController
        accessCode: string;
        events: Patersons.VerifyPhoneCtrl;        
    }
    
    export class VerifyPhoneCtrl {

        scope: Patersons.VerifyPhoneScope;
        location: ng.ILocationService;
        window: ng.IWindowService;
        state: angular.ui.IStateService;
        stateParams: angular.ui.IStateProvider;
        http: ng.IHttpService;        
        identityService: Patersons.IdentityService;

        static $inject = ['$scope', '$location', '$window', '$state', '$stateParams', '$http', 'identityService'];

        constructor($scope, $location, $window, $state, $stateParams, $http, identityService) {
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.http = $http;            

            this.scope.events = this;            
            var userId =  $stateParams.userId;                 
        }  

        save() {
            this.scope.$broadcast('show-errors-check-validity');

            if (this.scope.phoneForm.$invalid) {
                return;
            }
            alert('checking phone...');
        }
    }
}
